import { database } from '../firebase';
import { snapshotToArray } from '../helpers';

export const FETCH_OBJECTIVES = 'FETCH_OBJECTIVES';
export const UPDATE_OBJECTIVES = 'UPDATE_OBJECTIVES';
export const UPDATE_OBJECTIVE = 'UPDATE_OBJECTIVE';
export const DELETE_OBJECTIVE = 'DELETE_OBECTIVE';

export const addObjective = (objective) => async dispatch => {
    database.ref("/objectives").push(objective).then((value) => {
        objective.key = value.key;

        dispatch({
            type: UPDATE_OBJECTIVES,
            payload: objective
        });


    });
};

export const updateObjective = (objective) => async dispatch => {

    let updates = {};

    updates['/objectives/' + objective.key] = objective;

    database.ref().update(updates).then(function (value) {
        dispatch({
            type: UPDATE_OBJECTIVE,
            payload: objective
        });
    });;
};

export const fetchObjectives = () => async dispatch => {

    database.ref("/objectives").once("value", snapshot => {
        dispatch({
            type: FETCH_OBJECTIVES,
            payload: snapshotToArray(snapshot)
        });
    });
};

export const deleteObjective = (objective) => async dispatch => {
    database.ref("/objectives/" + objective.key).remove().then((value) => {

        dispatch({
            type: DELETE_OBJECTIVE,
            payload: objective
        });

    });
}